<template>
  <div>
    <v-subheader class="pl-0">
      {{ title }}
    </v-subheader>
    <v-flex
      style="width: 70%; float:left;"
      m-0
    >
      <v-slider
        v-model="percent"
        step="0.01"
        always-dirty
        persistent-hint
        thumb-label="always"
        min="-100"
        max="100"
        @input="handleInput"
      />
    </v-flex>
    <v-flex
      shrink
      ml-2
      style="margin-top: -16px; width: 80px; float:left;"
    >
      <v-text-field
        v-model="percent"
        prefix="%"
        hide-details
        single-line
        type="number"
        min="-100"
        max="100"
        @input="handleInput"
      />
    </v-flex>
  </div>
</template>

<script>

export default {
  name: 'NegativePercentageInput',
  props: {
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: Number,
      default: () => 100,
    },
  },
  data() {
    return {
      percent: this.value,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', this.percent);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/NegativePercentageInput.vue